module.exports = __webpack_public_path__ + "static/cloud_bg-88b1adaa6c89857172e47d38b5d4bc20.png";